import {
  EResponsiblePersonRole,
  type ICountry,
} from '@mahawi/eshop-common/src/types';
import React, { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';

import {
  type IOperatorFormValues,
  toOperatorInput,
} from '../components/product-safety/operator-form';
import OperatorsPage from '../components/product-safety/operators-page';
import { useAppDispatch } from '../hooks/use-app-dispatch';
import { type RootState } from '../reducers';
import {
  responsiblePersonSave,
  responsiblePersonsLoadAll,
} from '../reducers/product-safety/reducer';

function ResponsiblePersonsContainer(): React.ReactElement {
  const dispatch = useAppDispatch();
  const responsiblePersons = useSelector(
    (s: RootState) => s.ProductSafety.responsiblePersons,
  );
  const inProcess = useSelector((s: RootState) => s.ProductSafety.inProcess);
  const validationErrors = useSelector(
    (s: RootState) => s.ProductSafety.validationErrors,
  );

  useEffect((): void => {
    dispatch(responsiblePersonsLoadAll());
  }, [dispatch]);

  const onReload = useCallback((): void => {
    dispatch(responsiblePersonsLoadAll());
  }, [dispatch]);

  const onSave = useCallback(
    (values: IOperatorFormValues, countryType: ICountry): void => {
      dispatch(
        responsiblePersonSave({
          ...toOperatorInput(values, countryType),
          role: values.role ?? EResponsiblePersonRole.IMPORTER,
        }),
      );
    },
    [dispatch],
  );

  return (
    <OperatorsPage
      title="EU responsible persons"
      operators={responsiblePersons}
      withRole
      inProcess={inProcess}
      validationErrors={validationErrors}
      onReload={onReload}
      onSave={onSave}
    />
  );
}

export default ResponsiblePersonsContainer;
